<template>
  <div class="dropdown-menu">
    <div
      v-for="option in options"
      :key="option.id"
      class="menu-item"
      dropdown-closer
      :class="{ show: option.id === selectedOptionId }"
      @click="setSelectedOption(option)"
    >
      <div class="icon-wrapper">
        <WfIcon icon="checkmark" color="#FFF" />
      </div>
      <span>{{ option.name }}</span>
    </div>
  </div>
</template>
<script>
import WfIcon from '@/components/WfIcon.vue';

export default {
  components: {
    WfIcon,
  },
  props: {
    layer: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    selectedOptionId: {
      type: String,
      required: true,
    },
  },
  methods: {
    setSelectedOption(option) {
      this.$emit('set-selected-option', option);
    },
  },
};
</script>
